import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: "60px",
  },
  wrapHeader: {
    textAlign: "center",
    padding: "25px",
    background:"linear-gradient(90deg, rgba(23,164,235,1) 84%, rgba(0,107,161,1) 100%)",
    color:"#fff"
  },
  liquid: {
    fontSize: 13.5,
  },
  liquidPrimary: {
    fontSize: 13.5,
    fontWeight: "bold",
  },
  liquidSecondList: {
    maxWidth: "200px",
    fontSize: 12,
    color: theme.palette.textColor.gray,
  },
  liquidThird: {
    fontSize: 12,
    fontWeight: "bold",
  },
}));

export default useStyles;
